import { render, staticRenderFns } from "./MessageBtnSidebar.vue?vue&type=template&id=6aa0648d&scoped=true"
import script from "./MessageBtnSidebar.vue?vue&type=script&lang=js"
export * from "./MessageBtnSidebar.vue?vue&type=script&lang=js"
import style0 from "./MessageBtnSidebar.vue?vue&type=style&index=0&id=6aa0648d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0648d",
  null
  
)

export default component.exports